// extracted by mini-css-extract-plugin
export var dividerContainer = "_9v-0";
export var line = "_9v-1";